export default __webpack_public_path__ + "static/media/checked.829b12f2.svg";